module.exports = __webpack_public_path__ + "img/1F1E7-1F1EA.05e6ff74.svg";